/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { ReturnButton } from '../../../components/buttons/ReturnButton';
import { getCellStatus } from '../../../utils/FormatFunctions';
import Loader from '../../../components/Loader';
import { useAuth } from '../../../providers/auth';
import { usePageTracking } from '../../../hooks/usePageTracking';
import { AnalyticsIcon, AnalyticsModal } from '../../../components/analytics';

export function ModulesWeeksPage() {
  const { moduleId } = useParams();
  usePageTracking(`module_${moduleId}_weeks`);

  const [selectedWeek, setSelectedWeek] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/weeks?school_class_id=${moduleId}`;
  const { user } = useAuth();
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const {
    requestApi: reqApiModule,
    data: dataModule,
    loading: loadingModule,
    error: errorModule,
  } = useFetch('/v1/admin/classes');
  const navigate = useNavigate();

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'category.name', label: 'Categoria' },
    { name: 'status', label: 'Status' },
    { name: 'meetings', label: 'Encontros' },
    { name: 'stats', label: 'Estatísticas' },
  ];

  useEffect(() => {
    reqApiModule('get', null, `/v1/admin/classes/${moduleId}`);
  }, [moduleId]);

  if (loadingModule) {
    return <Loader />;
  }

  if (errorModule) {
    return (
      <ErrorState onRetry={() => reqApiModule('get', null, `/v1/admin/classes/${moduleId}`)} />
    );
  }
  const groupIds = user?.group?.id;
  const hasAnalyticsAccess = [1, 2, 3, 6, 7].includes(groupIds || 0);

  const handleOpenModal = (weekId: number) => {
    setSelectedWeek(weekId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedWeek(null);
  };

  return (
    <Box>
      <Flex>
        <ReturnButton previousPage="contents/modules" mb={5} />
        <PageTitle>Semanas do módulo {dataModule?.data?.name}</PageTitle>
      </Flex>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 7 && groupIds !== 3}
        loading={loading}
        rowActions={{
          show: false,
          edit: groupIds !== 7 && groupIds !== 6,
          delete: groupIds !== 7 && groupIds !== 6 && groupIds !== 3,
        }}
        columnWithAction={[
          {
            name: 'meetings',
            columnAction: (rowItem) => (
              <Button
                textTransform="uppercase"
                colorScheme="button.primary"
                onClick={() => navigate(`${rowItem.id}/meetings`)}
              >
                Ver encontros
              </Button>
            ),
          },
          {
            name: 'stats',
            columnAction: (rowItem) =>
              hasAnalyticsAccess ? (
                <AnalyticsIcon
                  tooltip="Ver estatísticas desta semana"
                  onClick={() => handleOpenModal(rowItem.id)}
                />
              ) : null,
          },
        ]}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />

      {/* Modal de Estatísticas */}
      <AnalyticsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        weekId={selectedWeek || undefined}
        type="week"
      />
    </Box>
  );
}
